export default {
  headerContent: {
    title: 'Sompo Sigorta Seyahat Sağlık Sigortası Ücretleri',
    slogan: "Seyahat Sağlık Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'SEYAHAT SAĞLIK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Sompo Sigorta Seyahat Sağlık Sigortası',
    description: {
      title: 'Sompo Sigorta Seyahat Sağlık Sigortası Nedir? ',
      content: [
        'Seyahat sigortası poliçesi, sizi mali kayba neden olabilecek çeşitli durum ve olaylardan korumak için kapsamlı bir şekilde tasarlanmıştır.',
        'Seyahat ve macera her zaman teşvik edilirken, gerçek şu ki, en iyi planlanmış geziler bile yanlış gidebilir. Kimse en kötüsüne hazırlanmak istemez, ancak bunu yapmak kesinlikle hayati önem taşır ve bu yüzden seyahat sigortası yaptırmalısınız. Seyahat sigortası teminatına yatırım yapmak, seyahatinizi korumanızı sağlarken, gönül rahatlığı ile tatilinize devam etmenizi sağlar.',
        'Sompo Sigorta yurt içi seyahat sağlık sigortası ve yurt dışı seyahat sağlık sigortası ile yolculuklarınızı güvence altına alıyor!',
        'İhtiyaçlarınıza en uygun online seyahat sigortasını bulmanıza yardımcı olmayı taahhüt ediyoruz! Seyahat sigortası karşılaştırma aracımızı kullanmak zamandan, enerjiden ve en önemlisi paradan tasarruf etmenize yardımcı olacaktır.'
      ]
    },
    subContent: {
      title: 'Sompo Sigorta Seyahat Sağlık Sigortası Paketleri Nedir?',
      content: [
        {
          paragraph: 'Yurt içi seyahatlerinizi güvence altına alan Sompo Sigorta ile seyahatlerinizde karşılaşabileceğiniz sağlık problemleri, bagaj kaybı ve acentenin iflası gibi acil durumlar teminat altına alınmaktadır.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Seyahat Sağlık Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Sompo Sigorta Seyahat Sağlık Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
